export const detectSafari = (): boolean => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
